module.exports = __webpack_public_path__ + "static/media/powerpoint_icon.b9532431.png";